module.exports = __webpack_public_path__ + "static/media/communities.4cffbb52.jpg";